import { SEND_OFFER_NOTIFICATION_API_URL } from "../components/Shared/constant";

const SendOfferNotificationAPI = (accessToken, id) => {
  const responce = window.axios
    .get(SEND_OFFER_NOTIFICATION_API_URL, {
      params: { manual: true, offer_scheme_id: id },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + accessToken,
      },
    })
    .then(function (result) {
      return {
        ...result.data,
        status: 200,
      };
    })
    .catch(function (error) {
      return {
        ...error?.response?.data,
        status: error?.response?.status,
      };
    });
  return responce;
};

export default SendOfferNotificationAPI;
